import { render, staticRenderFns } from "./searchResultsclr.vue?vue&type=template&id=3a89e78f&scoped=true&"
import script from "./searchResultsclr.vue?vue&type=script&lang=js&"
export * from "./searchResultsclr.vue?vue&type=script&lang=js&"
import style0 from "./searchResultsclr.vue?vue&type=style&index=0&id=3a89e78f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a89e78f",
  null
  
)

export default component.exports